<time class="time-ago selectable {{extraClass}}">
  <p class="selectable hidden-selection new-line-after"></p>
  <span class="selectable hidden-selection">[</span>
  {{ textSignal() }}
  <span class="selectable hidden-selection">]</span>
  <p class="selectable hidden-selection new-line-after"></p>
</time>
